import React from 'react';
import TrackerInputShell from './TrackerInputShell';

interface LightButtonProps {
  color: 'red' | 'yellow' | 'green';
  active?: boolean;
  last?: boolean;
  onClick(): void;
}

interface TrafficLightInputProps {
  name: string;
  value?: TrafficLightValue;
  callback: (value: number) => void;
}

const LightButton: React.FC<LightButtonProps> = ({ color, active, last = false, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={`f6 sans-serif round-input ba b--${color} ${last ? 'mr0' : 'mr1'} ${
      active ? `bg-${color}` : `b--${color}`
    }`}
  />
);

const TrafficLightInput: React.FC<TrafficLightInputProps> = ({ name, value, callback }) => (
  <TrackerInputShell trackerName={name}>
    <LightButton color="red" active={value === -1} onClick={() => callback(-1)} />
    <LightButton color="yellow" active={value === 0} onClick={() => callback(0)} />
    <LightButton color="green" active={value === 1} onClick={() => callback(1)} last={true} />
  </TrackerInputShell>
);

export default TrafficLightInput;
